/** @jsxImportSource @emotion/react */
import { Typography, createStyles, useTheme } from '@quickbit/qb-design-system';
import { Link, useNavigate } from 'react-router-dom';
import { useSetSession } from '../../context/Session';

export const PageNotAuthorized = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const setSession = useSetSession();
  const { palette } = useTheme();

  const handleLoginAgain = () => {
    void navigate('/login');
    setSession({ authenticated: false });
  };

  return (
    <section css={styles.container}>
      <div css={styles.content}>
        <Typography variant="heading2" color={palette.danger.default}>
          401
        </Typography>
        <Typography variant="heading1">
          Hold up! <br />
          you&apos;re not{' '}
          <span css={{ color: palette.danger.default }}>authorized </span>
          <br />
          to be here.
        </Typography>
        <div css={styles.body}>
          <Typography variant="captionSmallMedium" color={palette.grey.default}>
            &bull; Request permissions from the admin user. <br />
            &bull; You might need to login again.
          </Typography>

          <Typography variant="body" color={palette.grey.default}>
            Go back to our &nbsp;
            <Link css={styles.navigationLink} to="/" replace>
              homepage
            </Link>
            &nbsp; or try to &nbsp;
            <Link
              onClick={handleLoginAgain}
              css={styles.navigationLink}
              to="/"
              replace
            >
              login
            </Link>
            &nbsp; again.
          </Typography>
        </div>
      </div>
    </section>
  );
};

const useStyles = createStyles(({ spacing, palette }) => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    paddingLeft: spacing.xxs,
    borderLeft: `2px solid ${palette.grey.x200}`,
  },
  body: {
    marginBlock: spacing.xxs,
    '& > p': {
      marginTop: spacing.xxs,
    },
  },
  navigationLink: {
    textDecoration: 'none',
    color: palette.primary.default,
  },
}));
